import Vue from "vue";
import Vuex from "vuex";

import auth from "./modules/auth";
import user from "./modules/user";
import admin from "./modules/admin";
import organization from "./modules/organization";
import invite from "./modules/invite";
import classes from "./modules/classes";
import teachers from "./modules/teachers";
import students from "./modules/students";
import contracts from "./modules/contracts";
import org from "./v2/org";
import studysets from "./modules/studysets";
import assignments from "./modules/assignments";
import homeworks from "./modules/homeworks";
import branches from "./modules/branches";
import readAlouds from "./modules/readAlouds";
import aiTutor from "./modules/aiTutor";

import { localStoragePlugin } from "@/plugins/localStoragePlugin";

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  getters: {
  },
  modules: {
    auth,
    user,
    admin,
    organization,
    invite,
    classes,
    teachers,
    students,
    contracts,
    org,
    studysets,
    assignments,
    homeworks,
    branches,
    readAlouds,
    aiTutor,
  },
  plugins: [localStoragePlugin]
})

export default store
